<template>
  <div class="grid">
    <slot />
  </div>
</template>
